import {
    CREATE_CHECKING_DC_MASTER_REQUEST,
    CREATE_CHECKING_DC_MASTER_SUCCESS,
    CREATE_CHECKING_DC_MASTER_FAILURE,
    DELETE_CHECKING_DC_MASTER_REQUEST,
    DELETE_CHECKING_DC_MASTER_SUCCESS,
    DELETE_CHECKING_DC_MASTER_FAILURE,
    FETCH_SINGLE_CHECKING_DC_MASTER_REQUEST,
    FETCH_SINGLE_CHECKING_DC_MASTER_SUCCESS,
    FETCH_SINGLE_CHECKING_DC_MASTER_FAILURE,
    FETCH_CHECKING_DC_MASTER_REQUEST,
    FETCH_CHECKING_DC_MASTER_SUCCESS,
    FETCH_CHECKING_DC_MASTER_FAILURE,
    UPDATE_CHECKING_DC_MASTER_REQUEST,
    UPDATE_CHECKING_DC_MASTER_SUCCESS,
    UPDATE_CHECKING_DC_MASTER_FAILURE,
    RESET_CHECKING_DC_MASTER_INFO,
    CREATE_CHECKING_DC_MASTER_FORM,
    UPDATE_CHECKING_DC_MASTER_FORM,
    NAVIGATE_CHECKING_DC_DETAILS,
    NAVIGATE_CHECKING_DC_MASTER
} from './checkingDcMaster.actionsType';

export const CHECKING_DC_MASTER = 'checkingDc';

let initialState = {
    loading: false,
    checkingDcList: [],
    userform: { fldFKDeliveryAt: '', fldFKSupplierID: '' },
    selectedState: {},
    errorMessage: '',
    singleCheckingDcData: {},
    isCheckingDcDetails: false
};

export let checkingDcMasterReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_CHECKING_DC_MASTER_REQUEST:
        case CREATE_CHECKING_DC_MASTER_REQUEST:
        case UPDATE_CHECKING_DC_MASTER_REQUEST:
        case FETCH_SINGLE_CHECKING_DC_MASTER_REQUEST:
        case DELETE_CHECKING_DC_MASTER_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_CHECKING_DC_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                checkingDcList: updatePayload
            };
        case CREATE_CHECKING_DC_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: { fldFKDeliveryAt: '', fldFKSupplierID: '' }
            };
        case UPDATE_CHECKING_DC_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: { fldFKDeliveryAt: '', fldFKSupplierID: '' }
            };
        case FETCH_SINGLE_CHECKING_DC_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: updatePayload
            };
        case DELETE_CHECKING_DC_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: { fldFKDeliveryAt: '', fldFKSupplierID: '' }
            };
        case RESET_CHECKING_DC_MASTER_INFO:
            return {
                ...state,
                userform: { fldFKDeliveryAt: '', fldFKSupplierID: '' }
            };
        case CREATE_CHECKING_DC_MASTER_FORM:
        case UPDATE_CHECKING_DC_MASTER_FORM:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case FETCH_CHECKING_DC_MASTER_FAILURE:
        case CREATE_CHECKING_DC_MASTER_FAILURE:
        case UPDATE_CHECKING_DC_MASTER_FAILURE:
        case FETCH_SINGLE_CHECKING_DC_MASTER_FAILURE:
        case DELETE_CHECKING_DC_MASTER_FAILURE:
            return {
                ...state,
                loading: false
            };
        case NAVIGATE_CHECKING_DC_DETAILS:
            return {
                ...state,
                isCheckingDcDetails: true,
                singleCheckingDcData: updatePayload.singleCheckingDcData
            };
        case NAVIGATE_CHECKING_DC_MASTER:
            return {
                ...state,
                isCheckingDcDetails: false
            };
        default:
            return state;
    }
};
